<template>
  <div :class="$style.outerPadding">
    <div :class="$style.bg">
      <el-form>
        <el-form-item class="mb-0">
          <el-row :gutter="20" type="flex" justify="space-between">
            <el-col :span="19">
              <h5>是否開放顧客前台付款</h5>
            </el-col>
            <el-col :span="5" class="d-flex align-items-center justify-content-end">
              <el-switch v-model="cosmeticSettingData.skipPaymentMethod" active-text="是" inactive-text="否" :active-value="false" :inactive-value="true"></el-switch>
            </el-col>
          </el-row>
        </el-form-item>

        <!-- google login api 串接測試用 -->
        <!-- <button @click="handleAuthClick">Sign In with Google</button>
        <button @click="handleSignoutClick">Sign Out</button> -->

        <!-- 訂金功能 -->
        <!-- <el-form-item class="mb-0">
          <el-row :gutter="20" type="flex" justify="space-between">
            <el-col :span="19">
              <h5>是否開放訂金付款</h5>
            </el-col>
            <el-col :span="5" class="d-flex align-items-center justify-content-end">
              <el-switch v-model="cosmeticSettingData.enableFrontAdvancePayment" active-text="是" inactive-text="否" :active-value="true" :inactive-value="false"></el-switch>
            </el-col>
          </el-row>
        </el-form-item> -->
        <el-form-item v-if="cosmeticSettingData.enableFrontAdvancePayment" class="mb-0" label="訂金方式">
          <br />
          <el-row>
            <el-col :span="7">
              <el-radio v-model="cosmeticSettingData.frontAdvancePaymentType" label="fixed">固定金額</el-radio>
              <el-radio v-model="cosmeticSettingData.frontAdvancePaymentType" label="%">按訂單總額比例</el-radio>
            </el-col>
            <el-col :span="17" class="d-flex" :class="$style.input_setting">
              <el-input v-model="cosmeticSettingData.frontAdvancePaymentValue" type="number" placeholder="金額" class="mr-3" @input="handleInput"></el-input>{{ getUnit }}
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>

      <div :class="$style.serviceTreePadding">
        <el-form>
          <el-row>
            <el-col :span="24" :class="$style.overflowCategory">
              <el-form-item label="開放前台使用付款方式">
                <div :class="[$style.box]">
                  <template>
                    <div class="inner-box">
                      <el-button v-for="(item, index) in forSaveDeletePayMentList" :key="index" class="is-round is-fullwidth" style="text-align: left;">
                        <div class="flex-btn">
                          <div class="flex-btn-content">
                            <span class="btn-text">{{ item.name }}</span> <br />
                          </div>

                          <div class="flex-btn-icon" @click="deletePrepaid(item)">
                            <BaseIcon name="times"></BaseIcon>
                          </div>
                        </div>
                      </el-button>
                      <span v-if="!forSaveDeletePayMentList.length">請選擇開放的付款方式</span>
                    </div>
                  </template>
                  <el-button class="is-round is-fullwidth" style="overflow-x:auto" @click="createPayment"> <BaseIcon name="plus" /> 新增開放的付款方式 </el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <div :class="$style.footer">
            <el-button class="is-round">取消</el-button>
            <el-button class="is-round" data-tour-text="欄位修改後，記得儲存資料。" type="primary" :loading="tryingToStore" @click="tryToStore">儲存</el-button>
          </div>
        </el-form>

        <!-- 新增開放付款方式，跳窗 -->
        <el-dialog title="選取開放付款方式" :visible.sync="paymentDialog" width="550px" top="0" append-to-body>
          <el-input v-model="productFilterText" :placeholder="'搜尋'" class="is-border smsInput" style="margin-bottom: 15px;">
            <BaseIcon slot="prefix" name="search" class="el-input__icon" />
          </el-input>
          <el-form label-position="top" class="isWrap">
            <el-form-item style="min-height: 250px" :class="$style['services-wrap']">
              <div :class="$style['services-wrap__dialogTitle']">
                <el-checkbox v-model="checkAllPayment" :indeterminate="isIndeterminatePayment" style="margin-left: 5px; margin-top: 10px; margin-bottom: 5px" @change="handleCheckAllChange"
                  >全 選
                </el-checkbox>
              </div>
              <el-checkbox-group v-model="catchPayment" :class="$style.services" @change="handleCheckedPayment">
                <el-checkbox v-for="(product, index) in filterPaymentList" :key="index" :label="product.type" border>
                  {{ product.name }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
          <div class="btn-group-inline">
            <el-button class="is-round" @click="paymentDialog = false">取消</el-button>
            <el-button class="is-round" type="primary" @click="saveSelectProducts">儲存</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { merchantComputed } from '@state/helpers'
import { messageStore } from '@utils/message'
import i18n from '@locales/index'

const allPayment = [
  { type: 'Credit', name: '信用卡' },
  { type: 'Vacc', name: 'Atm 虛擬帳戶' },
  { type: 'Cash', name: '現金付款' },
  { type: 'StoreCredit', name: '現場刷卡' },
  { type: 'Atm', name: '線下匯款' },
  { type: 'Deposit', name: '儲值金抵扣' },
  { type: 'Prepaid', name: `${i18n.messages['zh_TW']['prepaid']['BASE']}方案抵扣` },
]
export default {
  name: 'TabFrontSet',
  data() {
    return {
      forSaveDeletePayMentList: [],
      productFilterText: '', // filter的文字
      paymentDialog: false, // 付款跳窗
      catchPayment: [], // 使用者選到的payment
      isIndeterminatePayment: false, // 不確定的checkbox狀態
      checkAllPayment: false, // 全選checkbox
      tryingToStore: false,
      submitData: {},
      cosmeticSettingData: {},
    }
  },
  computed: {
    ...merchantComputed,
    clonePayment() {
      let list = JSON.parse(JSON.stringify(allPayment))

      // 過濾 Credit/Vacc：只有 cashflowSetting === 1 才保留
      const { cashflowSetting } = this.currentMerchant || {}
      if (cashflowSetting !== 1) {
        list = list.filter((item) => item.type !== 'Vacc' && item.type !== 'Credit')
      }

      // 過濾 Deposit
      if (!this.$store.state.auth.currentUserComponents?.includes('deposit')) {
        list = list.filter((item) => item.type !== 'Deposit')
      }

      return list
    },
    filterPaymentList() {
      if (this.productFilterText.length === 0) {
        this.checkAllPayment = this.catchPayment.length === this.clonePayment.length
        this.isIndeterminatePayment = this.catchPayment.length > 0 && this.catchPayment.length < this.clonePayment.length
        return this.clonePayment
      } else {
        return this.clonePayment.filter((item) => item.name.includes(this.productFilterText))
      }
    },
    getUnit() {
      return this.cosmeticSettingData.frontAdvancePaymentType === 'fixed' ? '元' : '%'
    },
  },
  created() {
    this.submitData = JSON.parse(JSON.stringify(this.currentMerchant))
  },
  async mounted() {
    this.initPaymentList()
    await this.tryToGetCosmeticSettingData()
  },
  methods: {
    /**
     * @description 初始化清單
     */
    initPaymentList() {
      try {
        const { paymentMethods: paymentListFromDB } = this.currentMerchant
        if (paymentListFromDB && paymentListFromDB.length > 0) {
          let paymentList = this.clonePayment.filter((item) => paymentListFromDB.includes(item.type))
          this.forSaveDeletePayMentList = JSON.parse(JSON.stringify(paymentList))
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 儲存
     */
    async tryToStore() {
      try {
        this.tryingToStore = true
        const { frontAdvancePaymentValue, frontAdvancePaymentType } = this.cosmeticSettingData
        const isInvalidAdvancePaymentValue = frontAdvancePaymentValue < 0 || (frontAdvancePaymentType === '%' && frontAdvancePaymentValue > 100)

        if (isInvalidAdvancePaymentValue) {
          this.$message.error('請輸入正確數字')
          return
        }

        this.$set(this.submitData, 'paymentMethods', this.forSaveDeletePayMentList.map((item) => item.type))
        const paymentMethodsResult = await this.$store.dispatch('merchant/store', this.submitData)
        const cosmeticSettingResult = await this.$store.dispatch('merchant/postCosmeticBasicSet', {
          type: 'cosmetic',
          payload: this.cosmeticSettingData,
        })
        if (paymentMethodsResult.code === 200 && cosmeticSettingResult.response.code === 200) {
          await this.$store.dispatch('merchant/fetchSingle')
          messageStore('edit')
        }
      } catch (error) {
        this.$alert(error.message, {
          center: true,
        })
      } finally {
        this.tryingToStore = false
      }
    },

    saveSelectProducts() {
      this.paymentDialog = false
      this.forSaveDeletePayMentList = []
      this.clonePayment.forEach((item) => {
        if (this.catchPayment.includes(item.type)) {
          this.forSaveDeletePayMentList.push(item)
        }
      })
    },
    /**
     * @description 刪除各個item
     */
    deletePrepaid(item) {
      this.forSaveDeletePayMentList = this.forSaveDeletePayMentList.filter((listItem) => listItem.type !== item.type)
    },
    /**
     * @description 開啟跳窗
     */
    createPayment() {
      this.catchPayment = this.forSaveDeletePayMentList.map((item) => item.type)
      this.checkAllPayment = this.catchPayment.length === this.clonePayment.length
      this.isIndeterminatePayment = this.catchPayment.length > 0 && this.catchPayment.length < this.clonePayment.length
      this.paymentDialog = true
    },
    /**
     * @description change 全選要做的事
     */
    handleCheckAllChange(val) {
      try {
        if (!val && this.productFilterText.length > 0) {
          const filterText = this.filterPaymentList.map((item) => item.type)
          this.catchPayment = this.catchPayment.filter((item) => !filterText.includes(item))
        }
        if (val && this.productFilterText.length > 0) {
          const filterText = this.filterPaymentList.map((item) => item.type)
          this.catchPayment = [...this.catchPayment, ...filterText]
        }
        if (val && this.productFilterText.length === 0) {
          this.catchPayment = allPayment.map((item) => item.type)
        }
        if (!val && this.productFilterText.length === 0) {
          this.catchPayment = []
        }
        this.isIndeterminatePayment = false
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 點擊/改變選項會發生的事
     */
    handleCheckedPayment(value) {
      try {
        let checkedCount = value.length
        this.checkAllPayment = checkedCount === this.clonePayment.length
        this.isIndeterminatePayment = checkedCount > 0 && checkedCount < this.clonePayment.length
      } catch (error) {
        console.error(error.message)
      }
    },
    handleInput() {
      const data = this.cosmeticSettingData
      if (data.frontAdvancePaymentValue < 0) {
        data.frontAdvancePaymentValue = 0
        this.$message.error('數字不得小於0')
      }
      if (data.frontAdvancePaymentType === '%' && data.frontAdvancePaymentValue > 100) {
        data.frontAdvancePaymentValue = 100
        this.$message.error('比例不得大於100')
      }
    },
    async tryToGetCosmeticSettingData() {
      try {
        const request = await this.$store.dispatch('merchant/getCosmeticBasicSet', { type: 'cosmetic' })
        this.cosmeticSettingData = request.response.items
      } catch (err) {
        console.error(err)
      }
    },
    // google login api 串接測試用
    // async handleAuthClick() {
    //   const authInstance = gapi.auth2.getAuthInstance()
    //   await authInstance.signIn().then((googleUser) => {
    //     console.log('User signed in:', googleUser)
    //   })
    // },
    // async handleSignoutClick() {
    //   const authInstance = gapi.auth2.getAuthInstance()
    //   await authInstance.signOut().then(() => {
    //     console.log('User signed out')
    //   })
    // },
  },
}
</script>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';

.outerPadding {
  padding: 20px;
}

.bg {
  background-color: white;
  padding: 20px;
}

.overflowCategory {
  :global {
    .el-form-item__label {
      overflow-x: scroll;
      height: 40px;
    }
  }
}

.serviceTreePadding {
  padding: 0 0 20px;

  :global {
    .el-form-item__label {
      float: none !important;
    }
  }
}

.box {
  background-color: white;
  border: $color-border-light 1px solid;
  padding: 15px;
  border-radius: 6px;
  height: 360px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  :global {
    .inner-box {
      margin-bottom: 20px;
      overflow-y: scroll;

      :global {
        .el-button {
          margin-bottom: 15px;
          width: 24%;
          margin-right: 10px;
        }

        .el-button.is-fullwidth + .el-button.is-fullwidth {
          margin-top: 0 !important;
        }
      }
    }

    .box {
      &__title {
        white-space: normal;
        text-align: left;
        line-height: 1.4;
        max-width: calc(100% - 100px);
      }
    }

    .el-checkbox-group {
      display: flex;
      flex-wrap: wrap;
    }

    .el-checkbox.is-bordered {
      background-color: #fff;

      .el-checkbox__label {
        white-space: normal;
      }
    }

    .search-in-box {
      .el-input__inner {
        background-color: #fff;
        margin-left: 5px;
        margin-right: 5px;
        margin-bottom: 10px;
      }
    }

    .input-in-buttom {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
    }

    .el-form-item {
      margin-bottom: 15px;
    }

    .el-button {
      .el-input {
        width: 100px;
      }

      .el-input__inner {
        background-color: #fff;
        border-color: $color-border-base;
        height: 30px;
      }

      .el-input__suffix {
        top: 7px;
      }
    }

    .inline-section {
      display: flex;
      margin-bottom: 15px;
    }

    .el-button.is-no-border {
      border: 0;
    }
  }
}

.services-wrap {
  border: 1px solid $color-border-for-bg-white;
  border-radius: $border-radius;

  &__dialogTitle {
    background-color: $color-line;
    padding-left: 15px;
  }
}

.services {
  padding: 15px;

  :global {
    label.el-checkbox.is-bordered {
      width: calc(50% - 10px);
      display: inline-flex;
      margin: 5px;
      align-items: center;
      height: auto;
      padding: 15px 20px 15px 15px;

      @include max-sm {
        width: 100%;
      }

      .el-checkbox__label {
        padding-left: 15px;
        width: 100%;
        overflow-x: auto;
      }

      & + .el-checkbox.is-bordered {
        margin-left: 5px;
      }

      .title,
      .meta {
        width: calc(100% - 20px);
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
      }

      .content {
        width: 100%;
      }
    }
  }
}

.input_setting {
  :-webkit-outer-spin-button,
  :-webkit-inner-spin-button {
    margin: 0;
    -webkit-appearance: none !important;
  }

  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    margin: 0;
    -webkit-appearance: none !important;
  }
}
</style>
